import renderBattleModeScene from '@/lib/services/ui/scenes/battle-mode-scene/render-battle-mode-scene.js';

const battleModeScene = (canvas, state) => {
  // ======== 游戏模式选择场景渲染入口 ========
  renderBattleModeScene(canvas, state);
};

export default battleModeScene;
